import React from 'react'
import {
    Container, Row, Col, Label, Input, Button,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import {CustomerCompanyModel} from '../model/CustomerCompanyModel';
import {
    getCustomerCompanyInfo,
    insertCustomerCompanyInfo,
    updateCustomerCompanyInfo
} from '../model/request/customer_info'
import { Account, Roles } from '../model/Account'
import { getCustomerNames } from '../model/request/quotes'
import { ContactInformationViewController } from './ContactInformationViewController'
import { AddressViewController } from './AddressViewController'
import DropDownTextField from '../view/DropDownTextField'
import NumberTextField from '../view/NumberTextField'
import DrawingImageUploadView, { extensionForMimeType } from '../view/DrawingImageUploadView'
import { getCompanyLogoLink, uploadCompanyLogo } from '../model/request/companyLogo'

class CustomerInformationViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        this.state = {
            'company_name': props.customerName || '',
            'suggested_company_names': [],
            'customer_model': null,
            'is_new_customer': true,
            'account': account,
        }
    }

    componentDidMount() {
        if (!this.state.account.hasRole(Roles.Admin)) {
            this.getInfo('')
        } else if (this.props.customerName) {
            this.getInfo(this.props.customerName)
        }
    }

    updateCompanyDropDown(customerName) {
        if (customerName.length > 1) {
            getCustomerNames(customerName)
            .then(
                (result) => {
                    this.setState({
                        'suggested_company_names': result.data.customer_names
                    })
                },
                (error) => {
                    this.props.showError(error)
                }
            )
        } else {
            this.setState({
                'suggested_company_names': [],
            })
        }
    }

    updateCompany() {
        this.props.turnOffLoader()
        (this.state.is_new_customer
            ? insertCustomerCompanyInfo(this.state.customer_model, !this.state.account.hasRole(Roles.Admin))
            : updateCustomerCompanyInfo(this.state.customer_model, !this.state.account.hasRole(Roles.Admin))
        ).then(
            (success) => {
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    getInfo(company) {
        this.props.turnOffLoader()
        getCustomerCompanyInfo(company)
        .then(
            (company_info) => {
                this.setState({
                    'customer_model': company_info,
                    'is_new_customer': false,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.setState({
                    'customer_model': CustomerCompanyModel.from({
                        'company': company,
                        'is_new_customer': true,
                    }),
                })
                this.props.turnOffLoader()
            },
        )
    }

    // MARK: View

    renderLabelBody(label, body) {
        return <>
            <Row>
            <Col><Label
                style={{
                    'fontSize': '18pt',
                    'fontWeight': '400',
                }}
            >{label}</Label>
            </Col>
        </Row>
        <Row>
            {body}
        </Row>
        </>
    }

    renderBillingInfo(title, varName) {
        return <Row>
            <Col>
                <Container style={{'maxWidth': '700px', 'marginLeft': '8px'}}>
                    <ContactInformationViewController
                        title={title}
                        model={this.state.customer_model[varName]}
                        onUpdate={(fieldName, value) => {
                            this.setState((state) => {
                                const customer = state.customer_model
                                customer[varName][fieldName] = value
                                return {
                                    'customer_model': customer
                                }
                            })
                        }} />
                </Container>
            </Col>
        </Row>
    }

    renderCustomerModelLabelBody(label, body) {
        return <Row><Col><Container
                style={{
                    'maxWidth': '700px',
                    'marginLeft': '30px',
                }}
            >
            <Row><Col><Label
                style={{
                    'fontSize': '20pt',
                    'fontWeight': '400',
                }}
            >{label}</Label></Col></Row>
            <Row><Col><Container>{body}</Container></Col></Row>
        </Container></Col></Row>
    }

    renderCompanyLogoSlot() {
        const company = this.state.customer_model.company
        if (!company) {
            return null
        }
        return this.renderCustomerModelLabelBody('Logo',
            <DrawingImageUploadView
                label={`${company} Logo`}
                uploadFn={(file, name, onProgress) =>
                    uploadCompanyLogo(file, name, onProgress, company)}
                buildName={(mimeType) =>
                    `${company} Logo.${extensionForMimeType(mimeType)}`}
                imageUrl={getCompanyLogoLink(company)}
                mayNotExist
                downloadName={`${company} Logo`}
                onUploaded={() => {}}
                showError={this.props.showError}
                />,
        )
    }

    renderCustomerModel() {
        if (this.state.customer_model === null) {
            return <></>
        }
        return <>
            {this.renderCompanyLogoSlot()}
            {this.renderBillingInfo('Billing Info', 'billing_info')}
            {this.renderCustomerModelLabelBody('Website',
                <Input
                    type='text'
                    value={this.state.customer_model.website}
                    onChange={(e) => {
                        this.setState((state) => {
                            state.customer_model.website = e.target.value
                            return {
                                'customer_model': state.customer_model
                            }
                        })
                    }} />
            )}
            <Row><Col><Container>
            <AddressViewController
                model={this.state.customer_model.address}
                onUpdate={(fieldName, value) => {
                    this.setState((state) => {
                        state.customer_model.address[fieldName] = value
                        return {
                            'customer_model': state.customer_model
                        }
                    })
                }} />
            </Container></Col></Row>
            {this.renderBillingInfo('Contact Person', 'contact_person')}
            {this.state.account.hasRole(Roles.Asante) ?
            <>
            {this.renderCustomerModelLabelBody('Payment Terms Text',
                <Input
                    type='text'
                    value={this.state.customer_model.payment_terms_text}
                    onChange={(e) => {
                        this.setState((state) => {
                            state.customer_model.payment_terms_text = e.target.value
                            return {
                                'customer_model': state.customer_model
                            }
                        })
                    }} />
            )}
            {this.renderCustomerModelLabelBody('Payment Terms Days',
                <NumberTextField
                    showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                    style={{
                        'textAlign': 'right',
                    }}
                    value={this.state.customer_model.payment_days}
                    onChange={(e) => {
                        this.setState((state) => {
                            state.customer_model.payment_days = e.target.value
                            return {
                                'customer_model': state.customer_model,
                            }
                        })
                    }}/>
            )}
            </>
            : <Row><Col><Container
                style={{
                    'maxWidth': '700px',
                    'marginLeft': '30px',
                }}
            >
            {this.renderLabelBody(
                'Payment Terms',
                <Label>{this.state.customer_model.payment_terms_text}</Label>,
            )}
            </Container></Col></Row>
            }
            <Row
                className='quote-bottom-bottons-row'
                xs="1" sm="4"
            ><Col><Button
                color='success'
                size="lg"
                className="default-weight purchase-button"
                onClick={() => {
                    this.updateCompany()
                }}
            >Save</Button></Col></Row>
        </>
    }

    render() {
        return <Container>
            {this.state.account.hasRole(Roles.Admin) ?
            <>
            {this.renderLabelBody('Company',
                <>
                <Row><Col>
                <DropDownTextField
                    value={this.state.company_name}
                    values={this.state.suggested_company_names}
                    onChange={(e) => {
                        this.setState({
                            'company_name': e.target.value,
                        })
                        this.updateCompanyDropDown(e.target.value)
                    }}
                    onClickRow={(value, index) => {
                        this.setState({
                            'company_name': value,
                        })
                        this.updateCompanyDropDown(value)
                        this.getInfo(value)
                    }} />
                </Col></Row>
                </>
            )}
            <Row
                style={{
                    'marginTop': '12px',
                }}
            ><Col>
                <Button
                    onClick={() => {
                        this.getInfo(this.state.company_name)
                    }}
                >Get Info</Button>
            </Col></Row>
            </>
            : <></>
            }
            {this.renderCustomerModel()}
        </Container>
    }
}

export default CustomerInformationViewController
